import * as Yup from "yup";
import isEqual from "lodash.isequal";

import type { CustomAlertForm } from "./types";
import type { TypeSafeReactLocalization } from "../../../../composites";

// A regex for UUID v1-v5
const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const customAlertSchema = ({ getString }: TypeSafeReactLocalization) =>
  Yup.object<CustomAlertForm>({
    deliveryMethod: Yup.string()
      .required(getString("custom-alerts-form-error-delivery-method"))
      .notOneOf(
        ["unknown"],
        getString("custom-alerts-form-error-delivery-method"),
      ),
    model: Yup.string(),
    // If both values are provided, startAmount cannot exceed endAmount.
    greaterThanAmount: Yup.number()
      .nullable()
      .test(
        "greater-than-amount-max",
        getString("custom-alerts-form-error-greater-than-amount"),
        (value, context) =>
          context.parent.lessThanAmount === null ||
          value === null ||
          value === undefined ||
          +value < +context.parent.lessThanAmount,
      ),
    lessThanAmount: Yup.number()
      .nullable()
      .test(
        "less-than-amount-max",
        getString("custom-alerts-form-error-less-than-amount"),
        (value, context) =>
          context.parent.greaterThanAmount === null ||
          value === null ||
          value === undefined ||
          +value > +context.parent.greaterThanAmount,
      ),
    // Similarly, for balances.
    greaterThanBalance: Yup.number()
      .nullable()
      .test(
        "start-balance-max",
        getString("custom-alerts-form-error-greater-than-balance"),
        (value, context) =>
          context.parent.lessThanBalance === null ||
          value === null ||
          value === undefined ||
          +value <= +context.parent.lessThanBalance,
      ),
    lessThanBalance: Yup.number()
      .nullable()
      .test(
        "less-than-amount-max",
        getString("custom-alerts-form-error-less-than-balance"),
        (value, context) =>
          context.parent.greaterThanBalance === null ||
          value === null ||
          value === undefined ||
          +value > +context.parent.greaterThanBalance,
      ),
    description: Yup.string(),
    accounts: Yup.array()
      .of(
        Yup.string().matches(
          uuidRegex,
          getString("custom-alerts-form-error-accounts"),
        ),
      )
      .nullable()
      .test(
        "is-non-empty-or-null",
        getString("custom-alerts-form-error-accounts"),
        (value) => value === null || !isEqual(value, []),
      ),
  });
